import SEO from '../components/seo';
import Wrapper from '../layout/wrapper';
import EsqueciASenhaMain from '../components/esqueci-a-senha';

const SignIn = () => {
  return (
    <Wrapper>
      <SEO pageTitle={'Esqueci a senha'} />
      <EsqueciASenhaMain/>
    </Wrapper>
  );
};

export default SignIn;